import { useAuth0 } from '@auth0/auth0-react';
import { getQueryParam, sleep, useQueryParam } from '@mi-front/core';
import LoginIcon from '@mui/icons-material/Login';
import { Box, Button, CircularProgress } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

/**
 * Self-contained login button that triggers Auth0 redirect with current query params
 * (redirect_to, email). Uses a long sleep after click to avoid double submissions.
 */
export function LoginButton() {
  const redirectTo = useQueryParam('redirect_to');
  const { loginWithRedirect } = useAuth0();
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setLoading(true);
    try {
      loginWithRedirect({
        appState: { returnTo: redirectTo || '/' },
        authorizationParams: {
          login_hint: getQueryParam('email') ?? undefined,
        },
      });
      await sleep(10000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Button
        variant="outlined"
        color="primary"
        sx={{ minWidth: '10rem' }}
        disabled={loading}
        startIcon={loading ? <CircularProgress size={16} color="inherit" /> : <LoginIcon />}
        onClick={handleLogin}
      >
        <FormattedMessage id="auth.loginScreen.loginBtn" defaultMessage="Iniciar sesión" />
      </Button>
    </Box>
  );
}
